import { CLEAR_NOTICE, SHOW_NOTICE } from './constants';

/** The banner showing now, or null. A newer notice replaces it, as a newer push notification replaces the last. */
function reducer(state = null, action) {
  switch (action.type) {
    case SHOW_NOTICE:
      return action.payload;
    case CLEAR_NOTICE:
      return null;
    default:
      return state;
  }
}

export default reducer;

export const selectNotice = (state) => state.notices;
